import { createFileRoute } from '@tanstack/react-router'
import { MedicalsPage } from '~/features/dashboard/pages/medicals/pages'
import { MedicalsSearchParams } from '~/features/dashboard/pages/medicals/schemas';

export const Route = createFileRoute(
  '/(dashboard)/dashboard/medicals/$program/',
)({
  validateSearch: (search: Record<string, unknown>): MedicalsSearchParams => {
    return {
      prescription_id: search.prescription_id as string | undefined,
      payment_status: search.payment_status as "success" | "failed" | undefined,
      medication_id: search.medication_id as string | undefined,
    };
  },
  component: MedicalsPage,
})

